import { RichContent } from "./RichContent"
import { PullQuote } from "./PullQuote"
import { SectionHeader } from "./SectionHeader"
import { FullImage } from "./FullImage"
import { FeaturedCard } from "./FeaturedCard"
import { EmbeddedCode } from "./EmbededCode"
import { Stats } from "./Stats"
import { SponsorList } from "./SponsorList"
import { FAQList } from "./FAQList"
import { ProfileList } from "./ProfileList"
import { TestimonialList } from "./TestimonailList"
import { CallToAction } from "./CallToAction"
import { UpcomingEvents } from "./UpcomingEvents"
import { FeaturedEvents } from "./FeaturedEvents"
import { AudienceCards } from "./AudienceCards"
import { FeaturedCaseStudies } from "./featuredCaseStudies"
import { LatestResources } from "./LatestResources"
import { FeaturedResources } from "./FeaturedResources"
import { IconBar } from "./IconBar"
import { Buttons } from "./Buttons"
import { Cards } from "./Cards"
import { Video } from "./Video"

const components = {
  RichContent,
  PullQuote,
  SectionHeader,
  FullImage,
  FeaturedCard,
  EmbeddedCode,
  Stats,
  SponsorList,
  FAQList,
  ProfileList,
  TestimonialList,
  CallToAction,
  UpcomingEvents,
  FeaturedEvents,
  AudienceCards,
  FeaturedCaseStudies,
  LatestResources,
  FeaturedResources,
  IconBar,
  Buttons,
  Cards,
  Video,
}

const FallbackBlock = ({ typeHandle }) => <p>{typeHandle}</p>

export const ContentBlocks = ({ blocks }) => {
  return (
    <div className="flex flex-col gap-20 my-12">
      {blocks &&
        blocks.map((block) => {
          // either load from typeHandle or 'notFound'
          const Block = components[block.typeHandle] || FallbackBlock
          // return block, if exists, with deconstructed props
          return Block !== null && <Block key={block.uid} {...block} />
        })}
    </div>
  )
}
